.tooltip {
  display: inline-flex;
  position: relative;
  vertical-align: middle;
}

.tooltipOpen {
  z-index: 1001;
}

.tooltipSurface {
  background: var(--pgm-sys-color-inverse-surface);
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--pgm-sys-color-inverse-on-surface);
  font-family: var(--pgm-sys-typescale-body-small-font);
  font-size: var(--pgm-sys-typescale-body-small-size, 12px);
  font-style: normal;
  font-weight: var(--pgm-sys-typescale-body-small-weight, 400);
  letter-spacing: var(--pgm-sys-typescale-body-small-tracking, 0.4px);
  line-height: var(--pgm-sys-typescale-body-small-line-height, 16px);
  max-width: 320px;
  min-height: 24px;
  opacity: 0;
  padding: 4px 8px;
  pointer-events: none;
  position: absolute;
  transition:
    opacity 100ms cubic-bezier(0.2, 0, 0, 1),
    transform 100ms cubic-bezier(0.2, 0, 0, 1),
    visibility 0ms linear 100ms;
  transition-delay: 0ms;
  visibility: hidden;
  white-space: normal;
  width: max-content;
  z-index: 1000;
}

.tooltipOpen > .tooltipSurface {
  opacity: 1;
  transition-delay: 0ms;
  visibility: visible;
}

.tooltip.tooltipOpen > .tooltipSurface[role="tooltip"] {
  color: var(--pgm-sys-color-inverse-on-surface);
  font-family: var(--pgm-sys-typescale-body-small-font);
  font-size: var(--pgm-sys-typescale-body-small-size, 12px);
  font-style: normal;
  font-weight: var(--pgm-sys-typescale-body-small-weight, 400);
  letter-spacing: var(--pgm-sys-typescale-body-small-tracking, 0.4px);
  line-height: var(--pgm-sys-typescale-body-small-line-height, 16px);
}

.tooltipTop > .tooltipSurface,
.tooltipTopStart > .tooltipSurface,
.tooltipTopEnd > .tooltipSurface {
  bottom: calc(100% + 4px);
}

.tooltipBottom > .tooltipSurface,
.tooltipBottomStart > .tooltipSurface,
.tooltipBottomEnd > .tooltipSurface {
  top: calc(100% + 4px);
}

.tooltipTop > .tooltipSurface,
.tooltipBottom > .tooltipSurface {
  left: 50%;
  transform: translate(-50%, 2px);
}

.tooltipTopStart > .tooltipSurface,
.tooltipBottomStart > .tooltipSurface {
  left: 0;
  transform: translateY(2px);
}

.tooltipTopEnd > .tooltipSurface,
.tooltipBottomEnd > .tooltipSurface {
  right: 0;
  transform: translateY(2px);
}

.tooltipOpen.tooltipTop > .tooltipSurface,
.tooltipOpen.tooltipBottom > .tooltipSurface {
  transform: translate(-50%, 0);
}

.tooltipOpen.tooltipTopStart > .tooltipSurface,
.tooltipOpen.tooltipTopEnd > .tooltipSurface,
.tooltipOpen.tooltipBottomStart > .tooltipSurface,
.tooltipOpen.tooltipBottomEnd > .tooltipSurface {
  transform: translateY(0);
}
